import {Container, createTheme, CssBaseline} from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import {ThemeProvider} from "@mui/styles";

const theme = createTheme({
    typography: {
        fontFamily: [
            'Open Sans Condensed',
            'sans-serif'
        ].join(','),
    },
});

export const ChartContainer = ({children}) => {
  return (
      <ThemeProvider theme={theme}>
          <div style={{ textAlign: 'center'}}>
              <CssBaseline />
              <Container maxWidth="sm" sx={{ mt: '3rem'}}>
                  <Box>
                      {children}
                  </Box>
              </Container>
          </div>
      </ThemeProvider>
  );
}
